import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalqueryvideo-card',
  templateUrl: './helpbutton-reports-totalqueryvideo-card.component.html',
  styleUrls: ['./helpbutton-reports-totalqueryvideo-card.component.scss']
})
export class HelpbuttonReportsTotalqueryvideoCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
